<template>
  <path
    d="M21.99 8.00018C21.99 7.28018 21.62 6.65018 21.05 6.30018L13.01 1.59018C12.39 1.22018 11.61 1.22018 10.99 1.59018L2.95 6.30018C2.38 6.65018 2 7.28018 2 8.00018V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002L21.99 8.00018ZM10.94 12.3402L3.74 7.84018L10.99 3.59018C11.61 3.22018 12.39 3.22018 13.01 3.59018L20.26 7.84018L13.06 12.3402C12.41 12.7402 11.59 12.7402 10.94 12.3402Z"
  />
</template>
